// Time-of-day + weather-cycle environment config
import * as THREE from "three";

// elevation/azimuth in degrees -> normalized sun direction (from origin toward sun)
export function solarDir(elevationDeg, azimuthDeg) {
  const el = THREE.MathUtils.degToRad(elevationDeg);
  const az = THREE.MathUtils.degToRad(azimuthDeg);
  return new THREE.Vector3(
    Math.cos(el) * Math.sin(az),
    Math.sin(el),
    Math.cos(el) * Math.cos(az)
  ).normalize();
}

// Presets for the manual Time Settings menu
export const TIME_PRESETS = {
  morning: {
    label: "Morning",
    elevation: 34, azimuth: 100,
    night: false, cityLights: false,
    dirColor: "#fff2d6", ambientColor: "#a9c0e0", ambient: 0.95, dirIntensity: 1.6,
    skyTop: "#2f5f9c", skyBottom: "#a9cbe8",
    atmoInner: "#2a6cff", atmoOuter: "#ffe6a8",
    fog: "#cdddf0",
  },
  afternoon: {
    label: "Afternoon",
    elevation: 72, azimuth: 180,
    night: false, cityLights: false,
    dirColor: "#fff6e0", ambientColor: "#aebdd6", ambient: 0.8, dirIntensity: 1.0,
    skyTop: "#183a6b", skyBottom: "#6ea3d8",
    atmoInner: "#3a86ff", atmoOuter: "#ffe08a",
    fog: "#2a3f5f",
  },
  evening: {
    label: "Evening",
    elevation: 4, azimuth: 268,
    night: false, cityLights: true,
    dirColor: "#ff8a3d", ambientColor: "#6b6a8a", ambient: 0.72, dirIntensity: 0.9,
    skyTop: "#160b26", skyBottom: "#5a2a3a",
    atmoInner: "#3a4cff", atmoOuter: "#ffb24d",
    fog: "#1a1020",
  },
  night: {
    label: "Night",
    elevation: -12, azimuth: 300,
    night: true, cityLights: true,
    dirColor: "#8fa6d8", ambientColor: "#2c3550", ambient: 0.6, dirIntensity: 0.3,
    skyTop: "#03040c", skyBottom: "#0a1024",
    atmoInner: "#1b2f6b", atmoOuter: "#3a4a8a",
    fog: "#04060f",
  },
};

// Weather cycles: system selector + tints + wind/cloud behaviour
export const CYCLES = {
  hurricane: {
    id: "hurricane",
    label: "Hurricane",
    node: "hurricane_polo",
    windMode: "circular",
    cloudCycle: 0,
    tintLight: "#ffd9a0",   // warm tropical amber
    tintAmbient: "#c9a86a",
    atmoInner: "#2a6cff", atmoOuter: "#ffcf6e",
    precipSnow: false,
  },
  noreaster: {
    id: "noreaster",
    label: "Nor'easter",
    node: "noreaster",
    windMode: "diagonal",
    cloudCycle: 1,
    tintLight: "#bcd6e6",   // cold cyan/grey
    tintAmbient: "#7f95a8",
    atmoInner: "#3aa0ff", atmoOuter: "#9fd0ff",
    precipSnow: false,
  },
  blizzard: {
    id: "blizzard",
    label: "Blizzard",
    node: "noreaster",
    windMode: "diagonal",
    cloudCycle: 1,
    tintLight: "#dcecf7",   // cold, high-contrast white/grey
    tintAmbient: "#9fb2c4",
    atmoInner: "#4aa8ff", atmoOuter: "#cfe6ff",
    precipSnow: true,
  },
};

export function resolvePreset(timeOfDay, autoSolar) {
  if (timeOfDay === "auto" && autoSolar) {
    const base = autoSolar.night ? TIME_PRESETS.night : (TIME_PRESETS[autoSolar.period] || TIME_PRESETS.afternoon);
    return { ...base, elevation: autoSolar.sun_elevation, azimuth: autoSolar.sun_azimuth, night: autoSolar.night, label: "Automatic" };
  }
  return TIME_PRESETS[timeOfDay] || TIME_PRESETS.afternoon;
}

export function mix(a, b, t) {
  return new THREE.Color(a).lerp(new THREE.Color(b), t);
}
